import { FichaListaHomeContent } from './../model/ficha-lista-home-content.interface';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-ficha-status-home',
  templateUrl: './ficha-status-home.component.html',
})
export class FichaStatusHomeComponent {

  @Input() propostas: FichaListaHomeContent[] = [];
  @Input() idFase: number;
  @Output() quantidadeSos = new EventEmitter();
}
